import React, { useEffect, useRef, useState } from "react";
import "./Timeline.css";

import img1 from "../assets/images/2014.jpg";
import img2 from "../assets/images/2020.jpg";
import img3 from "../assets/images/2021.jpg";
import img4 from "../assets/images/2022.jpg";
import img5 from "../assets/images/2024.jpg";

const timelineData = [
  {
    year: "2014",
    category: "Education",
    title: "BAMS Graduation",
    content:
      "Completed BAMS with University 2nd Rank in the subject of Panchakarma.",
    image: img1,
  },
  {
    year: "2022",
    category: "Academia",
    title: "Postgraduate Achievement",
    content:
      "Secured University 2nd Rank in Research Methodology and Biostatistics during postgraduate studies.",
    image: img2,
  },
  {
    year: "2022",
    category: "Research",
    title: "Research Recognition",
    content:
      "Received the Best Paper Presentation Award at an International Seminar on Non-Communicable Diseases.",
    image: img3,
  },
  {
    year: "2024",
    category: "Specialization",
    title: "MD in Rasashastra & Bhaishajya Kalpana",
    content:
      "Completed MD in Rasashastra & Bhaishajya Kalpana and was ranked among the Top 5.",
    image: img4,
  },
  {
    year: "2024",
    category: "National Recognition",
    title: "National Thesis Award",
    content:
      "Secured 1st place in the All India Ayurveda PG Thesis Award for Best Thesis in Rasashastra & Bhaishajya Kalpana.",
    image: img5,
  },
];

const Timeline = () => {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const timelineRef = useRef(null);
  const timerRef = useRef(null);

  const currentItem = timelineData[index];

  const goTo = (newIndex) => {
    setIndex(newIndex);
  };

  const goNext = () => {
    setIndex((prev) => (prev + 1) % timelineData.length);
  };

  const goPrev = () => {
    setIndex(
      (prev) => (prev - 1 + timelineData.length) % timelineData.length
    );
  };

  /*
   * Automatically move through the milestones.
   * The slideshow pauses when the user hovers over the timeline.
   */
  useEffect(() => {
    if (isPaused) {
      return;
    }

    timerRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % timelineData.length);
    }, 6500);

    return () => {
      clearInterval(timerRef.current);
    };
  }, [isPaused]);

  /*
   * Keep the active timeline point visible on smaller screens.
   */
  useEffect(() => {
    if (!timelineRef.current) {
      return;
    }

    const activePoint = timelineRef.current.querySelector(
      ".timeline-point.active"
    );

    if (activePoint && window.innerWidth <= 768) {
      activePoint.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [index]);

  return (
    <section className="timeline-section">
      <div
        className="timeline-container"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Section Heading */}
        <div className="timeline-heading">
          <span className="timeline-eyebrow">HER JOURNEY</span>

          <h2>A Journey of Learning &amp; Ayurveda</h2>

          <div className="timeline-heading-line"></div>

          <p>
            From academic excellence to research and national recognition,
            every milestone reflects a continued commitment to learning,
            Ayurveda and patient care.
          </p>
        </div>

        {/* Timeline Navigation */}
        <div className="timeline-navigation-wrapper">
          <div className="timeline-navigation" ref={timelineRef}>
            <div className="timeline-line"></div>

            {timelineData.map((item, i) => (
              <button
                key={`${item.year}-${item.title}`}
                type="button"
                className={`timeline-point ${
                  index === i ? "active" : ""
                }`}
                onClick={() => goTo(i)}
                aria-label={`View ${item.year} ${item.title}`}
                aria-current={index === i ? "step" : undefined}
              >
                <span className="timeline-dot"></span>

                <span className="timeline-year">{item.year}</span>

                <span className="timeline-point-title">
                  {item.category}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Main Milestone Card */}
        <div className="timeline-feature">
          {/* Text */}
          <div className="timeline-feature-content">
            <div className="timeline-feature-year">
              {currentItem.year}
            </div>

            <div className="timeline-feature-category">
              {currentItem.category}
            </div>

            <h3>{currentItem.title}</h3>

            <div className="timeline-feature-divider"></div>

            <p>{currentItem.content}</p>

            {/* Navigation */}
            <div className="timeline-controls">
              <button
                type="button"
                className="timeline-arrow"
                onClick={goPrev}
                aria-label="Previous milestone"
              >
                <span>←</span>
              </button>

              <div className="timeline-counter">
                <strong>{String(index + 1).padStart(2, "0")}</strong>
                <span>/</span>
                <span>{String(timelineData.length).padStart(2, "0")}</span>
              </div>

              <button
                type="button"
                className="timeline-arrow"
                onClick={goNext}
                aria-label="Next milestone"
              >
                <span>→</span>
              </button>
            </div>
          </div>

          {/* Image */}
          <div className="timeline-feature-image">
            <div className="timeline-image-frame">
              <img
                key={currentItem.image}
                src={currentItem.image}
                alt={`${currentItem.year} - ${currentItem.title}`}
              />
            </div>

            <div className="timeline-image-year">
              {currentItem.year}
            </div>
          </div>
        </div>

        {/* Progress Indicators */}
        <div className="timeline-progress">
          {timelineData.map((item, i) => (
            <button
              key={`progress-${i}`}
              type="button"
              className={index === i ? "active" : ""}
              onClick={() => goTo(i)}
              aria-label={`Go to ${item.year} ${item.title}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;